export const setCategoriesId = (state, categoryId) => {
  state.categories.id = categoryId
}

export const setCategoriesList = (state, categories) => {
  state.categories.list = categories
}

export const setCategoriesCurrentId = (state, categoryId) => {
  state.categories.currentId = categoryId
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/mutations.js